import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Warranty} from '../../../models/warranties/warranty.model';
import {HttpService} from '../../../services/http.service';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';
import {Router} from '@angular/router';
import {CreditNote} from '../../../models/warranties/credit-note.model';

@Component({
  selector: 'app-cancel-modal',
  templateUrl: './cancel-modal.component.html',
  styleUrls: ['./cancel-modal.component.scss']
})
export class CancelModalComponent implements OnInit {
  titleContent: string;
  buttonContent: string;
  cancelButtonContent: string;
  refundSelected = false;
  confirmationMessage: string;
  successText: string;
  amount: number;
  comments: string;
  creditNote: CreditNote = new CreditNote();
  amountError: boolean;
  amountValueError: boolean;

  constructor(private modalService: NgbModal, private router: Router, private http: HttpService) {
  }

  @ViewChild('content') content;
  closeResult = '';

  @Input()
  warranty: Warranty;

  static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public openModal(warranty: Warranty) {
    this.loadContent(warranty);
    this.modalService.open(this.content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${CancelModalComponent.getDismissReason(reason)}`;
    });
  }

  onCancel() {
    if (this.warranty.invoiced) {
      this.refundContract();
    } else {
      this.cancelContract();
    }
  }

  refundContract() {
    if (this.refundSelected) {
      this.http.refundWarranty(this.warranty.id, this.amount, this.comments).subscribe(() => {
        this.modalService.dismissAll();
        SweetUtil.showSuccess(this.successText).then(() => {
          this.router.navigate(['/']).then();
        });
      });
    } else {
      this.cancelContract();
    }
  }

  cancelContract() {
    this.http.abortWarranty(this.warranty.id).subscribe(() => {
      this.modalService.dismissAll();
      SweetUtil.showSuccess(this.successText).then(() => {
        this.router.navigate(['/']).then();
      });
    });
  }

  ngOnInit(): void {
    this.creditNote.warrantyId = this.warranty.id;
  }

  isInvoiced() {
    return this.warranty.invoiced;
  }

  loadContent(warranty: Warranty) {
    this.warranty = warranty;
    this.buttonContent = 'yes';
    this.cancelButtonContent = 'cancel';
    if (this.warranty.invoiced) {
      this.titleContent = 'cancel-contract';
      this.buttonContent = 'ok';
      this.confirmationMessage = 'refund-contract-confirmation';
    } else if (this.warranty.warrantyStatus === 'Active') {
      this.titleContent = 'cancel-warranty';
      this.confirmationMessage = 'cancel-confirmation';
    } else {
      this.titleContent = 'abort-warranty';
      this.confirmationMessage = 'abort-confirmation';
    }
  }

  validate() {
    if (this.warranty.invoiced && this.refundSelected) {
      return this.amount && this.comments;
    }
    return true;
  }

  validateInput() {
    this.amountError = this.warranty.contract.contractRate < this.amount;
    this.amountValueError = this.amount <= 0;
  }

  getPaidAmount() {
    if (this.warranty.contract.amountToBeCharged > 0) {
      return this.warranty.contract.amountToBeCharged;
    }
    return this.warranty.contract.contractRate;
  }
}
